import { useTranslation } from "react-i18next";
import { FileClock } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

/** "Nháp" — the style has autosaved work not yet published to its public link. */
export function DraftBadge({ at, by }: { at: number; by?: string }) {
  const { t, i18n } = useTranslation();
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge className="shrink-0 gap-1 border-amber-200 bg-amber-50 px-1.5 text-[11px] text-amber-800 dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-300">
          <FileClock className="size-3" />
          {t("Nháp")}
        </Badge>
      </TooltipTrigger>
      <TooltipContent className="max-w-64">
        {t("Có bản nháp chưa cập nhật lên link công khai — lưu {{when}}{{by}}. Mở chỉnh sửa để tiếp tục hoặc bỏ nháp.", {
          when: new Date(at * 1000).toLocaleString(i18n.language),
          by: by ? ` ${t("bởi {{by}}", { by })}` : "",
        })}
      </TooltipContent>
    </Tooltip>
  );
}
